module.exports = __webpack_public_path__ + "static/media/girl1.6a430673.svg";